var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-form-item",class:{'is-required':_vm.required}},[_c('label',{staticClass:"el-form-item__label",style:({width: _vm.labelWidth})},[_vm._v("\n        "+_vm._s(_vm.label?_vm.label+":":""))]),_c('div',{staticClass:"el-form-item__content",style:({marginLeft: _vm.labelWidth})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }